var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3705 16.1914L24.0997 20.0154L17.3705 23.8395V16.1914ZM35.8333 7.56083V32.4418C35.8333 34.3149 34.3136 35.8346 32.4405 35.8346H7.55951C5.68637 35.8346 4.16666 34.3149 4.16666 32.4418V7.56083C4.16666 5.68769 5.68637 4.16797 7.55951 4.16797H32.4405C34.3136 4.16797 35.8333 5.68769 35.8333 7.56083ZM32.8646 20.0225C32.8646 20.0225 32.8646 15.8097 32.3274 13.7881C32.0305 12.6713 31.1611 11.7948 30.0513 11.498C28.051 10.9537 20 10.9537 20 10.9537C20 10.9537 11.949 10.9537 9.94865 11.498C8.8389 11.7948 7.96948 12.6713 7.67261 13.7881C7.13541 15.8026 7.13541 20.0225 7.13541 20.0225C7.13541 20.0225 7.13541 24.2353 7.67261 26.2569C7.96948 27.3737 8.8389 28.2148 9.94865 28.5117C11.949 29.0489 20 29.0489 20 29.0489C20 29.0489 28.051 29.0489 30.0513 28.5046C31.1611 28.2078 32.0305 27.3666 32.3274 26.2498C32.8646 24.2353 32.8646 20.0225 32.8646 20.0225Z",
    fill: "#666969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d8ce46e4e55d31d33c664af933f40f6e.svg";
export { ForwardRef as ReactComponent };